import { useQuery } from "@tanstack/react-query";

import { addressQuery } from "#modules/addresses/infra/address.query";

export const useAddress = (id: string | undefined) => {
  const { data, ...rest } = useQuery({ ...addressQuery(id) });

  return { address: data, ...rest };
};
